import _extends from "@babel/runtime/helpers/esm/extends";
import { useEffect, useState } from 'react';
export function showModal(id, args) {
  dispatch({
    type: 'demodal/open',
    payload: {
      id: id,
      args: args
    }
  });
}
export function hideModal(id) {
  dispatch({
    type: 'demodal/close',
    payload: {
      id: id
    }
  });
}
export function removeModal(id) {
  dispatch({
    type: 'demodal/remove',
    payload: {
      id: id
    }
  });
}

function reducer(state, action) {
  switch (action.type) {
    case 'demodal/open':
      {
        var _extends2;

        var _action$payload = action.payload,
            _id = _action$payload.id,
            args = _action$payload.args;
        var currentState = state[_id];
        return _extends({}, state, (_extends2 = {}, _extends2[_id] = _extends({}, currentState, {
          args: args,
          isOpen: true
        }), _extends2));
      }

    case 'demodal/close':
      {
        var _extends3;

        var _id2 = action.payload.id;
        var _currentState = state[_id2];
        return _extends({}, state, (_extends3 = {}, _extends3[_id2] = _extends({}, _currentState, {
          isOpen: false
        }), _extends3));
      }

    case 'demodal/remove':
      {
        var _id3 = action.payload.id;

        var newState = _extends({}, state);

        delete newState[_id3];
        return newState;
      }

    /* istanbul ignore next */

    default:
      throw new Error("Unhandled action: " + action);
  }
}

var listeners = [];
var memoryState = {};
export var dispatch = function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};
export var useStore = function useStore() {
  var _useState = useState(memoryState),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return state;
};